import { render, staticRenderFns } from "./SemaforosPro.vue?vue&type=template&id=afb17d10"
import script from "./SemaforosPro.vue?vue&type=script&lang=js"
export * from "./SemaforosPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports